import React from 'react';
import styled from '@emotion/styled';
import validation, { isRequired, isValidUrl } from '../utils/validation';
import InputField from './InputField';
import TargetField from './TargetField';

const HeightContainer = styled('div')`
  min-height: 75px;
`;

const ImagePrompt = ({ formData }) => {
  return (
    <HeightContainer>
      <InputField
        name="img_src"
        required={true}
        label="Image location"
        autoFocus={true}
        validate={validation(isRequired, isValidUrl)}
        formData={formData}
      />
      <InputField
        name="alt"
        required={true}
        label="Alt text"
        validate={validation(isRequired)}
        formData={formData}
      />
      <InputField
        name="href"
        label="Location"
        validate={validation(isValidUrl)}
        formData={formData}
      />
      <TargetField
        name="target"
        type="checkbox"
        label="Open in a new tab?"
        formData={formData}
        format={(value) => value === '_blank'}
        parse={(value) => value === true ? '_blank' : '_self'}
      />
    </HeightContainer>
  );
};

export default ImagePrompt;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/prompts/ImagePrompt.jsx